/* eslint-disable import/prefer-default-export */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateParcelAccount } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useUpdateParcelAccount() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: any }) => updateParcelAccount(id, payload),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries(userQueryKeys.parcelAccountDetails(id));
      queryClient.invalidateQueries(userQueryKeys.parcelAccounts({}).slice(0, 2));
    },
  });
}
